module.exports = __webpack_public_path__ + "img/logo-255x255.d97de0ab.png";